import { useEffect, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { inputCls } from "@/components/kit";

const Cell = ({ c, v, set, tid }) => {
  if (c.type === "select") return <select className={inputCls} value={v || ""} onChange={(e) => set(e.target.value, e)} data-testid={tid}><option value="">—</option>{c.options.map((o) => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}</select>;
  if (c.type === "check") return <input type="checkbox" className="h-4 w-4 accent-[#0B6E8F]" checked={!!v} onChange={(e) => set(e.target.checked)} data-testid={tid} />;
  return <input type={c.type || "text"} className={inputCls} value={v || ""} placeholder={c.ph || ""} onChange={(e) => set(e.target.value)} data-testid={tid} />;
};

export function EditableRows({ cols, rows, onSave, testId, addLabel = "Aggiungi riga", onPick, extra }) {
  const [list, setList] = useState(rows || []);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    setList(rows || []);
    setDirty(false);
  }, [rows]);
  const upd = (i, k, v) => {
    let row = { ...list[i], [k]: v };
    if (onPick) row = onPick(k, v, row);
    setList(list.map((r, j) => (j === i ? row : r)));
    setDirty(true);
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" style={{ minWidth: Math.max(640, cols.length * 130) }}>
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#7B929C]">{cols.map((c) => <th key={c.k} className="pb-1 pr-2 font-medium" style={{ width: c.w }}>{c.label}</th>)}<th className="w-8" /></tr></thead>
          <tbody>
            {list.map((r, i) => (
              <tr key={i} className="align-top">
                {cols.map((c) => <td key={c.k} className="pr-2 py-1">{c.render ? c.render(r) : <Cell c={c} v={r[c.k]} set={(v) => upd(i, c.k, v)} tid={`${testId}-${c.k}-${i}`} />}</td>)}
                <td className="py-1"><button onClick={() => { setList(list.filter((_, j) => j !== i)); setDirty(true); }} className="p-2 text-[#991B1B]/70 hover:text-[#991B1B]" data-testid={`${testId}-del-${i}`}><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!list.length && <div className="text-sm text-[#7B929C]">Nessuna riga ancora.</div>}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => { setList([...list, {}]); setDirty(true); }} data-testid={`${testId}-add`}><Plus size={14} className="mr-1" /> {addLabel}</Button>
        <Button size="sm" className="rounded-full" disabled={!dirty} onClick={() => onSave(list)} data-testid={`${testId}-save`}><Save size={14} className="mr-1" /> Salva</Button>
        {extra}
      </div>
    </div>
  );
}
